<template>
    

    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Custom Fields</div>
            <!-- <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" v-if="readonly" @click="trz_display()"><button class="btn btn-primary">Edit</button></div> -->
        <template>
            <!-- <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" v-if="readonly"><a @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a></div> -->
        </template>
        </div>

        <div v-if="readonly" class="col-md-12 pb-3 px-0">
    
            <div class="bank-info" v-for="(custom_attribute , index) in custom_attributes" :key="custom_attribute.id">
                <template v-if="custom_attribute.type < 5">
                    <div class="row pr-5 pl-4">
                        <div class="col-sm-6 title">{{custom_attribute.label}}</div>
                        <div class="col-sm-6 text">{{tdata[custom_attribute.id]}}</div>
                    </div>
                </template>
                <template v-if="custom_attribute.type == 5">
                    <div class="row pr-5 pl-4">
                        <div class="col-sm-6 title">{{custom_attribute.label}}</div>
                        <div class="col-sm-6 text">                               

                            <template v-if="tdata[custom_attribute.id] != null">                                                
                                <b-link class="" @click="downloadFileContent('/data/employee/' +c_id+'/files/'+  tdata[custom_attribute.id])"><b-icon icon="download" scale="1"></b-icon></b-link>
                            </template>

                            <template v-else>
                                No file uploaded.
                            </template>

                        </div>
                    </div>
                </template>
                <template v-if="custom_attribute.type == 6">
                    <div class="row pr-5 pl-4">
                        <div class="col-sm-6 title">{{custom_attribute.label}}</div>
                        <div class="col-sm-6 text">{{tdata[custom_attribute.id]}}</div>
                    </div>
                </template>
                <template v-if="custom_attribute.type == 7">
                    <div class="row pr-5 pl-4">
                        <div class="col-sm-6 title">{{custom_attribute.label}}</div>
                        <div class="col-sm-6 text">{{ custom_attribute.option_data[tdata[custom_attribute.id]] }}</div>
                    </div>
                </template>
                <template v-if="custom_attribute.type == 8">
                    <div class="row pr-5 pl-4">
                        <div class="col-sm-6 title">{{custom_attribute.label}}</div>
                        <div class="col-sm-6 text">
                            <template v-for="s in tdata[custom_attribute.id]">                                
                                {{ custom_attribute.option_data[s]}}
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    
    
        <!-- <div :class="trz_display_form"> -->
        <div class="d-none">
            <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

            <div class="col-md-12">
                <b-form @submit.stop.prevent="onSubmit" id="frm">
                
                    <div class=" " v-for="(custom_attribute , index) in custom_attributes" :key="custom_attribute.id">
                        
                        <b-form-group id="label-group" :label="custom_attribute.label" :label-for="custom_attribute.label">
                            
                            <template v-if="custom_attribute.type == 1">
                                <b-form-input v-model="fdata[custom_attribute.id]" ></b-form-input>
                                
                            </template>
                            <template v-else-if="custom_attribute.type == 2">
                                <b-form-textarea v-model="fdata[custom_attribute.id]" rows="3" max-rows="6"></b-form-textarea>
                                
                            </template>
                            <template v-else-if="custom_attribute.type == 3">
                                <b-form-datepicker v-model="fdata[custom_attribute.id]" class="mb-2"></b-form-datepicker>
                                
                            </template>
                            <template v-else-if="custom_attribute.type == 4">
                                <b-form-input v-model="fdata[custom_attribute.id]"></b-form-input>
                                
                            </template>
                            <template v-else-if="custom_attribute.type == 5">
                                <div class="clearfix">
                                    <div class="float-left">
                                        <b-form-file v-model="files[custom_attribute.id]" class="mt-3 " plain></b-form-file>
                                    </div>
                                    <template v-if="tdata[custom_attribute.id] != ''">    
                                        <div class="float-left pt-3">                                            
                                            <b-link class=" cmpny-dwnld-btn" @click="downloadFileContent('/data/employee/' +c_id+'/files/'+  tdata[custom_attribute.id])"><b-icon icon="download" scale="1.5"></b-icon></b-link>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <template v-else-if="custom_attribute.type == 6">
                                <b-form-select v-model="fdata[custom_attribute.id]" :options="yes_no"></b-form-select>                                    
                            </template>


                            <template v-else-if="custom_attribute.type == 7">
                                <b-form-select v-model="fdata[custom_attribute.id]" :options="custom_attribute.options"></b-form-select>
                            </template>




                            <template v-else-if="custom_attribute.type == 8">
                                <b-form-checkbox-group v-model="fdata[custom_attribute.id]" :options="custom_attribute.options"></b-form-checkbox-group>
                                
                                <!--<template v-for="s in tdata[custom_attribute.id]">                                
                                    {{ custom_attribute.option_data[s]}}
                                </template>-->
                            </template>
                            
                            

                            
                            
                            
                            
                            
                            
                            

                            <input type="hidden" v-model="fake" /> <!-- this hidden input used here to display the form data immediately by a kik -->
                        </b-form-group>
                    </div>

                    
                    <b-card class="border-0 no-padding-card no-shadow mb-3">
                        <b-button class="border rounded float-right py-1" type="submit" variant="success" size="lg">Save</b-button>
                    </b-card>
                
                </b-form>
            </div>
        </div>
    </div>

</template>


<script>
export default{
    
    mounted() {
        this.fake = this.fake + 1;
        //console.log('Bank info started..');   
        //console.log(this.employee_id);  
//1 for single line, 2 for multiline, 3 for date, 3 for date, 4 for number, 5 for file, 6 for yes_no, 7 for single option, 8 for multi option 
        
    },
    props: [],
    data(){            
        
        return {
            cu : window.location.href,
            ce : false,  
            c_id : 0,
            readonly : true,
            trz_display_form : 'd-none',
            reset_flg : false,
            fake : 0,
            custom_attributes : [],
            successmsg : '',
            errormsg : [],
            blankmsg : 'Fetching data..',
            yes_no: [
                { value: "Yes", text: "Yes" },
                { value: "No", text: "No" },
            ],
            fdata : [],
            tdata : [],
            files : [],
            showoverlay : false,

        }
    },
    methods:{
       
        trz_display: function()
        {
            this.trz_display_form = '';
            this.readonly = !this.readonly;
            this.fake = this.fake + 1;
        },
        trz_display_data: function()
        {
            this.trz_display_form = 'd-none';
            this.readonly = !this.readonly;
            this.fake = this.fake + 1;
        },
        getCustomAttributeData: function()
        {
            if(!this.checkNet()) return false;
            
            axios.get(this.$api_url+'/front/custom/attribute/listdata' , {
                params: {
                    
                }
            }).then(function(response){
                //console.log(response.data);
                this.custom_attributes = response.data;
                if(this.custom_attributes.length == 0)
                {
                    this.blankmsg = "Nothing found.";
                }
                else
                {
                    this.c_id = this.custom_attributes[0].company_id;

                    this.getEmployeeCustomAttributeData();             
                }
                                           
                
               
                   
            }.bind(this));
        }, 
        getEmployeeCustomAttributeData: function(reset = 0)
        {
            if(!this.checkNet()) return false;
            


            axios.get(this.$api_url+'/front/custom/attribute/employee/data?reset='+reset , {
                params: {
                    
                }
            }).then(function(response){
                console.log(response.data);

                if(response.data.length == 0)
                {
                    
                    this.readonly = true;
                    this.trz_display_form = '';
                }
                else
                {
                    let tmp_data = response.data;

                    tmp_data.forEach(element => {
                        //console.log(element.attribute_id + ' >>> ' + element.value);
                        
                        if(element.type != 5)
                        {
                            this.fdata[element.attribute_id] = element.value;                                
                        }

                        this.tdata[element.attribute_id] = element.value;
                            
                        
                    });

                    this.readonly = true;
                    this.trz_display_form = 'd-none';
                    
                    
                    if(reset == 1)
                        this.reset_flg = false;
                    else
                        this.reset_flg = true;

                    this.fakeMe();
                }

                

            }.bind(this));
        }, 
        onSubmit(e) 
        {
            if(!this.checkNet()) return false;

            e.preventDefault();
            let currentObj = this;
                           
            console.log(this.fdata);
            //return;
            /*//let formData = new FormData();
            let myForm = document.getElementById('frm'); 
            let formData = new FormData(myForm);
            const data = []; 
            // need to convert it before using not with XMLHttpRequest
            for (let [key, val] of formData.entries()) {
                Object.assign(data, {[key]: val});
                
            }                
            formData.append('tmp_data_' , data);*/

            const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

            let formData = new FormData();
                                
            for (let [key, value] of Object.entries(this.fdata)) 
            {
                var nm = `${key}`;
                var fval = `${value}`;
                formData.append(nm, fval);                    
            } 

            if(this.files)
            {
                this.files.forEach((value, index) => {                        
                    formData.append('files_'+index , this.files[index]);
                });
                
            }


            axios.post(this.$api_url+'/front/custom/attribute/employee', formData)
                            .then(function (response) 
                            {                             
                                //this.custom_attributes = response.data;
                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    }); 

                                this.fake = this.fake + 1;

                                //this.$bvModal.hide('bv-modal-example');
                                //this.showoverlaymodal = false;                                    
                                //this.resetForm();
                                
                            }.bind(this))
                            .catch(function (error) 
                            {                     
                                console.log(error);               
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;                                    
                                for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    }); 
                                    
                                }
                            });
                            this.getCustomAttributeData();
                            this.trz_display_data();
                        //this.showoverlay = false;
        
            
        },

        fakeMe()
        {
            this.fake = this.fake + 1;
        }

    },
    created: function(){
        
        this.getCustomAttributeData();
        
        //Fire.$on('reloadFake', () => {this.fakeMe()})

        this.$emit('fakeMe');
        
    },
    
}
</script>
